import * as Immutable from 'immutable';
import {
  GET_PLANWITHDRAWABLE_ABORTED,
  GET_PLANWITHDRAWABLE_REQUESTED,
  GET_PLANWITHDRAWABLE_COMPLETED,
  GET_PLANWITHDRAWABLE_FAILED,
  GET_PLANWITHDRAWABLE_RESET,
  ADD_PLANWITHDRAWABLE_FORMDATA_REQUESTED,
  ADD_PLANWITHDRAWABLE_FORMDATA_FAILED,
  ADD_PLANWITHDRAWABLE_FORMDATA_COMPLETED,
  SUBMIT_WITHDRAWAL_COMPLETED,
  SUBMIT_WITHDRAWAL_FAILED,
  SUBMIT_WITHDRAWAL_REQUESTED,
} from '../../actions/planwithdrawable/types';
import { Action } from '../../utils/redux';

type ReducerActions =
  | Action<typeof GET_PLANWITHDRAWABLE_ABORTED>
  | Action<typeof GET_PLANWITHDRAWABLE_REQUESTED>
  | Action<typeof GET_PLANWITHDRAWABLE_RESET>
  | Action<typeof GET_PLANWITHDRAWABLE_COMPLETED, { items: PlanWithdraw[] }>
  | Action<typeof GET_PLANWITHDRAWABLE_FAILED, Error>
  | Action<typeof SUBMIT_WITHDRAWAL_REQUESTED>
  | Action<typeof SUBMIT_WITHDRAWAL_COMPLETED, { items: PlanWithdraw[] }>
  | Action<typeof SUBMIT_WITHDRAWAL_FAILED, Error>
  | Action<typeof ADD_PLANWITHDRAWABLE_FORMDATA_REQUESTED>
  | Action<
      typeof ADD_PLANWITHDRAWABLE_FORMDATA_COMPLETED,
      { items: PlanWithdraw[] }
    >
  | Action<typeof ADD_PLANWITHDRAWABLE_FORMDATA_FAILED, Error>;

export interface PlanWithdraw {
  PlanID: string;
  isWithdrawable: boolean;
  PlanWithdraw: {
    ProductCategory: string;
    PortalOwnershipName: string;
    MaxDailyWithdrawal: number;
    MaxTimeToProcess: string;
    CurrentBalance: number;
    MaxWithdrawalAmount: number;
    BankAccountID: string;
    BankAccount: string;
    AccountNumber: string;
    SortCode: string;
    AccountName: string;
    withdrawalFormData?: {
      withdrawAllFunds?: boolean;
    };
  };
}

export interface State {
  error: null | Error;
  data:
    | boolean
    | {
        items: PlanWithdraw[];
      };
  resettingdata: boolean;
  updattingdata: boolean;
  gettingdata: boolean;
  gotdata: boolean;
  updateddata: boolean;
  createingwithdrawal: boolean;
  createwithdrawal: boolean;
  createwithdrawalerror: null | Error;
}

const schema: State = {
  error: null,
  data: { items: [] },
  resettingdata: false,
  gettingdata: false,
  updattingdata: false,
  gotdata: false,
  updateddata: false,
  createingwithdrawal: false,
  createwithdrawal: false,
  createwithdrawalerror: null,
};

export const initialState = Immutable.Map(schema);

const reducer = (state = initialState, action: ReducerActions) => {
  switch (action.type) {
    case GET_PLANWITHDRAWABLE_ABORTED: {
      return state.set('error', null).set('gettingdata', false);
    }

    case GET_PLANWITHDRAWABLE_REQUESTED: {
      return state.set('error', null).set('gettingdata', true);
    }

    case GET_PLANWITHDRAWABLE_RESET: {
      return state
        .set('error', null)
        .set('data', { items: [] })
        .set('gettingdata', false);
    }

    case GET_PLANWITHDRAWABLE_COMPLETED: {
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);
    }

    case GET_PLANWITHDRAWABLE_FAILED: {
      return state.set('error', action.payload);
    }

    case ADD_PLANWITHDRAWABLE_FORMDATA_REQUESTED: {
      return state.set('error', null).set('updattingdata', true);
    }

    case ADD_PLANWITHDRAWABLE_FORMDATA_COMPLETED: {
      return state
        .set('error', null)
        .set('updattingdata', false)
        .set('updateddata', true)
        .set('data', action.payload);
    }

    case ADD_PLANWITHDRAWABLE_FORMDATA_FAILED: {
      return state.set('error', action.payload);
    }

    case SUBMIT_WITHDRAWAL_REQUESTED: {
      return state
        .set('createwithdrawalerror', null)
        .set('createingwithdrawal', true);
    }

    case SUBMIT_WITHDRAWAL_COMPLETED: {
      return state
        .set('error', null)
        .set('createingwithdrawal', false)
        .set('createwithdrawal', action.payload);
    }

    case SUBMIT_WITHDRAWAL_FAILED: {
      return state
        .set('createingwithdrawal', false)
        .set('createwithdrawalerror', action.payload);
    }

    default:
      return state;
  }
};

export default reducer;
